module.exports = __webpack_public_path__ + "static/media/image1.9c3e9ceb.jpg";